/** @file English catalog part of area E5 (W3-03): the Weights panel strings. */

/** The `weights` panel block (spread into `panels`). */
export const weightsEn = {
  weights: {
    title: 'Mesh & weights',
    noMesh: 'Select a slot that shows a mesh, or a mesh vertex.',
    binding: 'Binding',
    meshLine: '{mesh} on {slot} · {n} vertices',
    rigid: 'Rigid: follows its slot bone',
    skinned: 'Skinned: weighted to bones',
    makeSkinned: 'Make skinned',
    makeRigid: 'Make rigid',
    rebind: 'Rebind at setup',
    smooth: 'Smooth weights',
    bones: 'Bones',
    paintWith: 'Paint with {bone}',
    vertexCount: '{n} vertices',
    noVertices: 'Select vertices to edit their weights.',
    remove: 'Remove',
    addBone: 'Bone to add',
    add: 'Add',
  },
} as const;
